class PrivacyPopupElement extends HTMLElement {
	resolve({ allowAnalytics }) {
		localStorage.setItem("cookies", JSON.stringify({ prompted: true, allowAnalytics }));

		const googleAnalytics = document.getElementById("ga-template");

		if (allowAnalytics) {
			document.body.append(...googleAnalytics.content.childNodes);
		}

		googleAnalytics.remove();

		this.classList.remove("open");
	}

	constructor() {
		super();

		if (!location.search.includes("cookies=none")) {
			let { prompted, allowAnalytics } = JSON.parse(localStorage.getItem("cookies") ?? "null") ?? { prompted: false, allowAnalytics: false };

			if (prompted) {
				this.resolve({ allowAnalytics });
			}
			else {
				this.classList.add("open");
			}

			this.addEventListener("click", event => {
				if (event.target instanceof HTMLButtonElement || event.target instanceof HTMLAnchorElement) {
					switch (event.target.name) {
						case "accept-all":
							this.resolve({ allowAnalytics: true });
							break;
						case "customize":
							this.classList.add("customizing");
							break;
						case "save":
							this.resolve({ allowAnalytics });
							break;
						case "policy":
							window.open("/privacy-policy?cookies=none", "_blank", "popup,width=900,height=600");
							break;
					}
				}
			});

			this.addEventListener("change", event => {
				if (event.target instanceof HTMLInputElement) {
					switch (event.target.name) {
						case "analytics":
							allowAnalytics = event.target.checked;
							break;
					}
				}
			})
		}
	}
}

customElements.define("san-privacy-popup", PrivacyPopupElement);